import { useAuth } from '../context/AuthContext';

// Definição de limites e permissões por plano
const PLAN_LIMITS = {
    basico: {
        maxProducts: 50,
        maxClients: 20,
        maxOrders: null, // sem limite
        features: {
            dashboard: true,
            dashboardCharts: false,
            products: true,
            sales: true,
            expenses: true,
            clients: true,
            orders: false,
            reports: false,
            exportData: false,
            advancedReports: false,
        },
    },
    profissional: {
        maxProducts: null, // ilimitado
        maxClients: null, // ilimitado
        maxOrders: null, // ilimitado
        features: {
            dashboard: true,
            dashboardCharts: true,
            products: true,
            sales: true,
            expenses: true,
            clients: true,
            orders: true,
            reports: true,
            exportData: true,
            advancedReports: false,
        },
    },
    premium: {
        maxProducts: null,
        maxClients: null,
        maxOrders: null,
        features: {
            dashboard: true,
            dashboardCharts: true,
            products: true,
            sales: true,
            expenses: true,
            clients: true,
            orders: true,
            reports: true,
            exportData: true,
            advancedReports: true,
        },
    },
};

export function usePermissions() {
    const { userProfile } = useAuth();

    const plan = userProfile?.plan || 'basico';
    const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.basico;

    const hasFeature = (feature) => {
        return limits.features[feature] || false;
    };

    const canAddProduct = (currentCount) => {
        if (limits.maxProducts === null) return true;
        return currentCount < limits.maxProducts;
    };

    const canAddClient = (currentCount) => {
        if (limits.maxClients === null) return true;
        return currentCount < limits.maxClients;
    };

    const canAddOrder = (currentCount) => {
        if (limits.maxOrders === null) return true;
        return currentCount < limits.maxOrders;
    };

    const getUpgradeMessage = (feature) => {
        const messages = {
            orders: 'Faça upgrade para o plano Profissional para usar a Gestão de Pedidos',
            reports: 'Faça upgrade para o plano Profissional para acessar Relatórios',
            exportData: 'Faça upgrade para o plano Profissional para Exportar Dados',
            advancedReports: 'Faça upgrade para o plano Premium para acessar Relatórios Avançados',
            dashboardCharts: 'Faça upgrade para visualizar gráficos no dashboard',
        };

        return messages[feature] || 'Faça upgrade para acessar este recurso';
    };

    const getProductLimit = () => limits.maxProducts;
    const getClientLimit = () => limits.maxClients;
    const getOrderLimit = () => limits.maxOrders;

    const isPlanActive = () => {
        return userProfile?.subscriptionStatus === 'active';
    };

    return {
        plan,
        limits,
        hasFeature,
        canAddProduct,
        canAddClient,
        canAddOrder,
        getProductLimit,
        getClientLimit,
        getOrderLimit,
        getUpgradeMessage,
        isPlanActive,
    };
}
